import {
  ActionsObservable,
  combineEpics,
  StateObservable
} from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, exhaustMap, mergeMap, startWith } from 'rxjs/operators';
import axios from '../../axios-pod';
import { IState } from '../../models/states';
import actionTypes from '../../utilities/actionTypes';
import { fetchAssets, resetFetchCount } from '../actions/assetActions';
import { setScreenFilters } from '../actions/filterActions';
import { fetchUsers } from '../actions/userActions';
import {
  fetchPlaylists,
  resetPlaylistFetchCount
} from './../actions/playlistActions';

import { ScreenType } from '../../utilities/utilities';
import { fetchPlayoutUrls } from '../actions/playoutActions';
import {
  addScreenSuccess,
  deleteScreenSuccess,
  fetchScreensPending,
  fetchScreensSuccess,
  IAddScreen,
  IDeleteScreen,
  IFetchScreens,
  IUpdateScreen,
  IUpdateSelectedScreen,
  updateScreenSuccess,
  updateSelectedScreen,
  updateSelectedScreenSuccess
} from '../actions/screenActions';

export const onLoadScreens = (action$: ActionsObservable<IFetchScreens>) =>
  action$.ofType(actionTypes.FETCH_SCREENS).pipe(
    exhaustMap((action: IFetchScreens) => {
      // const state = state$.value; // extract the states
      return from(
        axios.get('/screens', {
          params: {
            userId: action.userId
          }
        })
      ).pipe(
        mergeMap(response => {
          const oldSelectedScreen = localStorage.getItem('podSelectedScreen');
          const result: any[] = [fetchScreensSuccess(response.data.result)];
          if (oldSelectedScreen) {
            // check if screen is valid
            result.push(updateSelectedScreen(oldSelectedScreen, true));
          }
          // result.push(fetchAssets(true)); // todo: remove the coupling from assets
          result.push(setScreenFilters(response.data.result));
          return result;
        }),
        catchError(_ => of()),
        startWith(fetchScreensPending())
      );
    })
  );

// fetch the asset then update the selected asset
export const onUpdateSelectedScreen = (
  action$: ActionsObservable<IUpdateSelectedScreen>,
  state$: StateObservable<IState>
) =>
  action$.ofType(actionTypes.UPDATE_SELECTED_SCREEN).pipe(
    mergeMap((action: IUpdateSelectedScreen) => {
      const result: any = [];
      const state = state$.value; // extract the states
      const { selectedScreen, screenMap } = state.screens;
      const { customers } = screenMap[selectedScreen];
      result.push(updateSelectedScreenSuccess(action.screenId));
      if (state.screens.screenMap[action.screenId].type === ScreenType.INGEST) {
        if (action.isFetchAssets) {
          result.push(resetFetchCount());
          result.push(fetchAssets(true));
        }
      } else if (
        state.screens.screenMap[action.screenId].type === ScreenType.PLAYLIST
      ) {
        result.push(resetPlaylistFetchCount());
        result.push(fetchPlaylists(true));
      } else {
        const customerNameList = customers.map(customer => {
          return customer.name;
        });
        const feedCodes = customers.flatMap(customer => customer.channels);
        result.push(fetchPlayoutUrls(feedCodes, customerNameList));
        // result.push(fetchPlaylists(true));
      }
      return result;
    }),
    catchError(_ => of())
  );

export const onAddScreen = (action$: ActionsObservable<IAddScreen>) =>
  action$.ofType(actionTypes.ADD_SCREEN).pipe(
    exhaustMap((action: IAddScreen) => {
      const payload = action.payload;
      const params = {
        name: payload.name,
        type: payload.type,
        customers: payload.customers,
        timezone: payload.timezone
      };
      return from(axios.post(`/screen`, params)).pipe(
        mergeMap(res => {
          const result: any[] = [addScreenSuccess(res.data.result)];
          return result;
        }),
        catchError(_ => of())
      );
    })
  );
export const onUpdateScreen = (action$: ActionsObservable<IUpdateScreen>) =>
  action$.ofType(actionTypes.UPDATE_SCREEN).pipe(
    exhaustMap((action: IUpdateScreen) => {
      const payload = action.payload;
      const params = {
        screen_id: payload.screenID,
        name: payload.name,
        customers: payload.customers,
        type: payload.type,
        timezone: payload.timezone
      };
      return from(axios.put(`/screen/${payload.screenID}`, params)).pipe(
        mergeMap(res => {
          const result: any[] = [updateScreenSuccess(res.data.result)];
          return result;
        }),
        catchError(_ => of())
      );
    })
  );
export const onDeleteScreen = (action$: ActionsObservable<IDeleteScreen>) =>
  action$.ofType(actionTypes.DELETE_SCREEN).pipe(
    exhaustMap((action: IDeleteScreen) => {
      const screenId = action.screenId;
      return from(axios.delete(`/screen/${screenId}`)).pipe(
        mergeMap(_ => {
          const result: any[] = [deleteScreenSuccess(screenId), fetchUsers()];
          return result;
        }),
        catchError(_ => of())
      );
    })
  );

export default combineEpics(
  onLoadScreens,
  onUpdateSelectedScreen,
  onAddScreen,
  onUpdateScreen,
  onDeleteScreen
);
